import { gtmDataLayerPush } from '../../../gtm'

export const otherTopicsContactGtmPushTrackFullStoryPageLoad = (
  context: string,
): void => {
  gtmDataLayerPush({
    event: 'fs_page_prop',
    fs_page_properties: {
      pageName: 'contact',
      type: context,
    },
  })
}
